export const EXAM_API = {
  GET_EXAM_BY_CONTENT_ID: `/v1/exams/byContentId/{contentId}`,
  START_EXAM: `/v1/exams/{id}/start`,
  FINISH_EXAM: `/v1/exams/{id}/finish`,
  CANCEL_EXAM: `/v1/exams/{id}/cancel`,
  RESULT_EXAM: `/v1/exams/{id}/result`,

  GET_EXAM_QUESTION_LIST: `/v1/exams/{id}/questions`,
  ANSWER_EXAM_QUESTION: `/v1/exams/{id}/questions/{questionId}/answer`,
};
